import { Account } from '@modules-deprecated/app/accounts/types'
import { getContact } from '@modules-deprecated/app/contacts/utils/getContact'
import { ChartOfAccountId } from '@modules-deprecated/app/organization/enums/chartOfAccountId'
import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { autoCompleteBillForm } from './autoCompleteBillForm'
import { BillForm } from './formData'
import { getBillFormFromAttachmentData } from './getBillFormFromAttachmentData'
import { getBillFormFromBookkeepingTagForm } from './getBillFormFromBookkeepingTag'
import { getBillFormFromExpenseCategoryForm } from './getBillFormFromExpenseCategory'
import { getBillFormFromVendorData } from './getBillFormFromVendorData'

interface GetBillFormAutoCompletedProps {
  accounts?: Account[]
  baseCurrencyId?: string
  billForm: BillForm
  chartOfAccountId?: ChartOfAccountId
  locale: string
  organizationId: string
  taxRates?: TaxRate[]
  withBookkeepingSuggestions?: boolean
  countryId?: string
}

export const getBillFormAutoCompleted = async ({
  accounts,
  baseCurrencyId,
  billForm,
  chartOfAccountId,
  organizationId,
  locale,
  taxRates,
  withBookkeepingSuggestions,
  countryId,
}: GetBillFormAutoCompletedProps): Promise<BillForm> => {
  let billFormUpdated = billForm

  // autocomplete using bohr data
  const attachmentFile = billForm?.attachmentsFiles?.[0]

  if (attachmentFile) {
    const billFormAttachmentData = await getBillFormFromAttachmentData({
      attachmentFile,
      billForm,
      chartOfAccountId,
      countryId,
      locale,
      organizationId,
      taxRates,
      withBookkeepingSuggestions,
    })
    billFormUpdated = autoCompleteBillForm({
      billFormDefault: billFormUpdated,
      billFormOverrides: billFormAttachmentData,
      baseCurrencyId,
      onlyFirstBillLine: false,
    })
  }

  // autocomplete using vendor
  const vendorId = billFormUpdated?.vendor?.id || billForm?.vendor?.id
  const vendor = vendorId ? await getContact(vendorId) : undefined

  if (vendor) {
    const billFormVendor = await getBillFormFromVendorData({
      accounts,
      billForm: billFormUpdated,
      locale,
      organizationId,
      organizationCountryCode: countryId || 'DK',
      taxRates,
      vendor,
    })
    billFormUpdated = autoCompleteBillForm({
      billFormDefault: billFormUpdated,
      billFormOverrides: billFormVendor,
      baseCurrencyId,
    })
  }

  // autocomplete using bookkeeping hero
  const billFormBookeepingHero = getBillFormFromBookkeepingTagForm({
    billForm: billFormUpdated,
    taxRates,
    accounts,
    organizationCountryCode: countryId || 'DK',
    vendor,
  })
  billFormUpdated = autoCompleteBillForm({
    billFormDefault: billFormUpdated,
    billFormOverrides: billFormBookeepingHero,
    baseCurrencyId,
  })

  // autocomplete using expenses category
  const billFormExpenseCategory = getBillFormFromExpenseCategoryForm(billFormUpdated, accounts, taxRates)
  billFormUpdated = autoCompleteBillForm({
    billFormDefault: billFormUpdated,
    billFormOverrides: billFormExpenseCategory,
    baseCurrencyId,
  })

  return billFormUpdated
}
